import {
  AutosuggestProps,
  TMDBSearchDropdownItem
} from "@bluframe/mightychroma-mightytool-frontend-types"

import TMDBSearchDropdown from "./TMDBSearchDropdown"

export interface Props {
  disabled?: boolean
  hasSelectedIcon?: boolean
  label?: string
  onSelect: AutosuggestProps["onSuggestionClick"]
  type?: "movie" | "tv" | "both"
  suggestions?: TMDBSearchDropdownItem[]
  loading?: boolean
  onSearch?: (query: string) => void
  selected?: string
}

export interface ComponentProps extends Props {}

export default TMDBSearchDropdown
